module.exports = __webpack_public_path__ + "static/img/bidding.c6edd9d2.png";